
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { BrainCircuit } from 'lucide-react';
import CitrullineSection from './CitrullineSection';
import OtherIngredientsSection from './OtherIngredientsSection';
import UsageInstructions from './UsageInstructions';

const DetailedInfo = () => {
  return (
    <Card className="bg-card backdrop-blur-sm border border-border mb-6">
      <CardHeader className="pb-3 md:pb-4">
        <CardTitle className="text-xl md:text-2xl font-bold mb-1 text-primary leading-tight">Ingrediens Breakdown – Deep Dive</CardTitle>
      </CardHeader>
      <CardContent className="prose prose max-w-none pt-0 space-y-4 md:space-y-6">
        <p className="text-base md:text-lg font-medium text-foreground leading-snug">
          Nedenfor går vi gjennom hver ingrediens, sammenligner med hva du typisk finner i andre produkter, og viser deg forskningen som underbygger dosene våre.
        </p>
        
        <h2 className="text-xl md:text-2xl font-bold text-primary flex items-center gap-2 mt-4 md:mt-6">
          <BrainCircuit className="text-primary" size={22} />
          Ingredienser
        </h2>

        <div className="space-y-4 md:space-y-6">
          <CitrullineSection />
          <div className="h-px bg-border/50"></div>
          <OtherIngredientsSection />
        </div>
        
        <div className="h-px bg-border/50 my-4 md:my-6"></div>
        
        <UsageInstructions />
      </CardContent>
    </Card>
  );
};

export default DetailedInfo;
